import React from 'react';

function DecisionCard({ response }) {
  const { questions, options, recommendation } = response;

  return (
    <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl border border-white/20 p-8 space-y-8">
      {questions && questions.length > 0 && (
        <div>
          <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl flex items-center justify-center">
              <span className="text-white text-lg">❓</span>
            </div>
            Clarifying Questions
          </h3>
          <div className="grid gap-4 md:grid-cols-2">
            {questions.map((question, index) => (
              <div key={index} className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-2xl border border-blue-100 shadow-sm hover:shadow-md transition-shadow">
                <p className="text-blue-800 font-medium leading-relaxed">{question}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {options && options.length > 0 && (
        <div>
          <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl flex items-center justify-center">
              <span className="text-white text-lg">🎯</span>
            </div>
            Options Analysis
          </h3>
          <div className="grid gap-6 md:grid-cols-3">
            {options.map((option, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <h4 className="font-bold text-gray-800 mb-4 text-lg">{option.title}</h4>
                
                <div className="space-y-4">
                  <div>
                    <h5 className="text-sm font-semibold text-green-700 mb-3 flex items-center gap-2">
                      <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                        <span className="text-green-600 text-sm">✅</span>
                      </div>
                      Pros
                    </h5>
                    <ul className="text-sm text-gray-600 space-y-2">
                      {option.pros.map((pro, proIndex) => (
                        <li key={proIndex} className="flex items-start gap-3">
                          <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                          <span className="leading-relaxed">{pro}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  <div>
                    <h5 className="text-sm font-semibold text-red-700 mb-3 flex items-center gap-2">
                      <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center">
                        <span className="text-red-600 text-sm">❌</span>
                      </div>
                      Cons
                    </h5>
                    <ul className="text-sm text-gray-600 space-y-2">
                      {option.cons.map((con, conIndex) => (
                        <li key={conIndex} className="flex items-start gap-3">
                          <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></div>
                          <span className="leading-relaxed">{con}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {recommendation && (
        <div className="bg-gradient-to-r from-green-50 via-blue-50 to-purple-50 border border-green-200 rounded-3xl p-8">
          <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-xl flex items-center justify-center">
              <span className="text-white text-lg">🏆</span>
            </div>
            Final Recommendation
          </h3>
          <div className="grid gap-6 md:grid-cols-2">
            <div className="bg-white p-6 rounded-2xl border border-green-200 shadow-lg">
              <h4 className="font-bold text-green-800 mb-3 text-lg">Best Choice:</h4>
              <p className="text-gray-800 font-medium">{recommendation.choice}</p>
            </div>
            <div className="bg-white p-6 rounded-2xl border border-blue-200 shadow-lg">
              <h4 className="font-bold text-blue-800 mb-3 text-lg">Reasoning:</h4>
              <p className="text-gray-700 leading-relaxed">{recommendation.reasoning}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DecisionCard; 